import React, { Fragment } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Button, Card, CardBody, Col, Container, Row ,Input} from 'reactstrap';
import { RibbonPayMethod } from '../../../constant';
import { usePayMethods } from '../../../hooks/payMethods/usePayMethods';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalPayMethods } from '../../../components/payMethods/ModalPayMethods';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexPayMethods = () => {

    const {
        payMethods, method,
        name, abbreviation, handleInputChange, validaciones,
        modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        modalAlert, showDeleteAlert,
        closeDialog, closeDeleteAlert,
        handleExcelPayMethod, loadingExcel,
        handleSearchPayMethod,
        handleClearPayMethod,
        searchPayMethod

    } = usePayMethods();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_pay_method)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_pay_method)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            {/* <Breadcrumb parent="Configuraciones" title={"Métodos de pago"} /> */}
            <div className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de métodos de pago"
                                    buttonActions={handleExcelPayMethod}
                                    titleButton="Listado de sitios"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear método de pago"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchPayMethod}
                                    valueFilter={searchPayMethod}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearPayMethod}
                                />
                        
                                <div className="table-responsive">
                                    <DataTable
                                        value={payMethods}
                                        paginator
                                        rows={15}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[15, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
            
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="abbreviation" header="Abreviatura" headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                                
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
  
            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar método de pago"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el método de pago:?"
                    alert1={true}
                    titleAlert1={name}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />

            )}

            <ModalPayMethods
                {
                ...{
                    modal, modalTitle, closeDialog, method, loading,
                    name, abbreviation, handleInputChange, validaciones,
                    saveCreate, saveUpdate, saveDelete
                }
                }
            />
        </Fragment>
    )
}
